<template>
    <v-col :cols="cols" class="ma-0 pa-0">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
        >
            <template v-slot:activator="{ on, attrs }">
                <div class="form-group">
                    <label
                        ><span class="outlabel">{{ outerLabel }}</span></label
                    >
                    <v-text-field
                        v-model="dateFormatted"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="date = parseDate(dateFormatted)"
                        v-on="on"
                        :append-icon="icon"
                        outlined
                        :label="label"
                        :placeholder="placeholder"
                        readonly
                        dense
                        :style="cssVars"
                        :rules="rules"
                        pre
                        :error-messages="errormsg"
                    ></v-text-field>
                </div>
            </template>
            <v-date-picker
                v-model="date"
                no-title
                @input="input"
                locale="pt-MX"
                scrollable
                :min="min === true ? minim : ''"
                :max="max === true ? maxim : ''"
            ></v-date-picker>
        </v-menu>
    </v-col>
</template>
<script>
export default {
    props: [
        'outerLabel',
        'dateProps',
        'cols',
        'icon',
        'label',
        'placeholder',
        'rules',
        'errormsg',
        'min',
        'max',
        'color'
    ],

    data: function() {
        return {
            date: this.dateProps,
            dateFormatted: this.formatDate(this.dateProps),
            menu: false
        }
    },

    computed: {
        computedDateFormatted() {
            return this.formatDate(this.date)
        },

        cssVars() {
            return {
                '--bg-color': this.color
            }
        }
    },

    watch: {
        date(val) {
            this.dateFormatted = this.formatDate(this.date)
        },

        dateProps: function(newVal, oldVal) {
            this.date = newVal
            this.dateFormatted = this.formatDate(this.date)
        }
    },

    methods: {
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        input(date) {
            this.menu = false
            this.$emit('input', date)
        }
    }
}
</script>
<style scoped>
::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
    background: white;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
    top: 10px;
    font-family: 'Inter';
    font-size: 12px !important;
    font-weight: 400;
    color: #050c42;
}

.v-text-field >>> input {
    flex: 1 1 auto;
    line-height: 20px;
    padding: 8px 0 8px;
    max-width: 100%;
    min-width: 0px;
    width: 100%;
    font-size: 12px !important;
    font-family: Inter;
    color: #050c42 !important;
    background-color: white;
    border: 5px;
}
.v-text-field >>> label {
    font-family: Inter;
    color: #050c42;
    font-size: 12px;
    font-weight: 500;
}

::v-deep .v-input--dense > .v-input__control > .v-input__slot {
    margin-bottom: 0px;
}
.v-input:hover >>> label {
    color: var(--bg-color) !important;
}
::v-deep.v-text-field:hover fieldset,
.v-text-field.v-input--has-state fieldset {
    border: 1px solid var(--bg-color);
}

::v-deep.v-text-field:hover fieldset,
.v-text-field.v-input--has-state fieldset {
    border: 1px solid var(--bg-color);
}

.bg {
    background-color: var(--bg-color) !important;
}
::v-deep.v-text-field--full-width .v-input__prepend-outer,
.v-text-field--full-width .v-input__prepend-inner,
.v-text-field--full-width .v-input__append-inner,
.v-text-field--full-width .v-input__append-outer,
.v-text-field--enclosed .v-input__prepend-outer,
.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field--enclosed .v-input__append-inner,
.v-text-field--enclosed .v-input__append-outer {
    margin-top: 17px;
    margin-left: 10px !important;
}

::v-deep .v-input--is-disabled.v-text-field--outline .v-input__slot {
    border: 0px solid red;
}
.outlabel {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
}
</style>
